import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, getAuthToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null | false | object
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        // If no token and no cookie, skip the /me call
        if (!getAuthToken()) {
          // still try once in case cookie is present
        }
        const res = await api.get("/auth/me");
        setUser(res.data);
      } catch (e) {
        setAuthToken(null);
        setUser(false);
      } finally {
        setChecked(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    if (res.data?.token) setAuthToken(res.data.token);
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setAuthToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
